import { useNode } from "@craftjs/core";
import Image from "next/legacy/image";
import * as React from "react";
import type { Vendor } from "src/types";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import ImageBackdrop from "@/components/editor/shared/expo/booth-card/image-backdrop-component";
import BoothCardSettings from "@/components/editor/shared/expo/booth-card-settings/booth-card-settings-component";

import {
  ContentWrapper,
  Description,
  Header,
  Heading,
  Logo,
  Wrapper,
} from "./booth-card-component-styles";

export type BoothCardProps = {
  vendor: Vendor;
};

export default function BoothCard(props: BoothCardProps) {
  const {
    connectors: { connect },
  } = useNode();

  const backgroundImageSrc = React.useMemo(
    () => props.vendor.background_image,
    [props.vendor.background_image]
  );

  if (!props.vendor) {
    return null;
  }

  return (
    <Wrapper ref={connect} data-testid="booth-card">
      <ImageBackdrop backgroundImageSrc={backgroundImageSrc}>
        <Image
          className="booth-banner-image"
          alt={`${props.vendor.name} banner`}
          src={backgroundImageSrc}
          data-testid="booth-banner"
          layout="responsive"
          objectFit="contain"
          unoptimized
          width={392}
          height={195}
          draggable="false"
        />
      </ImageBackdrop>
      <ContentWrapper>
        <Header>
          <Logo
            alt={`${props.vendor.name} logo`}
            src={props.vendor.image_url}
            data-testid="booth-logo"
            draggable="false"
          />
          <Heading data-testid="booth-name">{props.vendor.name}</Heading>
        </Header>
        <Description data-testid="booth-description">
          {props.vendor.headline}
        </Description>
      </ContentWrapper>
    </Wrapper>
  );
}

BoothCard.craft = {
  custom: {
    displayName: "Booth Card",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: BoothCardSettings,
  },
};
